import store from '@/store'
import { uniqid } from '@/js/utils'
import data_status from '@/data/data_status'



export const generate_status = (data) => {
	if (data && data.slug && (data.value > 0 || data.value === "infinite")) {
		let status = data_status.find((s) => s.slug === data.slug)
		if (status) {
			return {
				id: uniqid(),
				...status,
				turn: data.turn ? data.turn : store.getters.game.current_turn,
				value: data.value
			}
		}
	}
	return null
}



export const trigger_status = (data) => {
	if (data.card && data.status && data.status.turn !== store.getters.game.current_turn && data.status.value !== "infinite") {

		if (triggers[data.status.slug]) triggers[data.status.slug](data)

		const value = data.status.value - 1
		if (value <= 0) {
			store.dispatch('remove_card_status', { card: data.card, status: data.status })
		} else {
			store.commit('EDIT_GAME_OBJ', { obj: data.status, value })
		}
	}
}


const triggers = {

	poison: (data) => {
		store.dispatch('deal_damage', { victim: data.card, damage: 1, no_animation: true })
		// store.commit('EDIT_GAME_OBJ', { obj: data.card, life: data.card.life - 1 })
	}

}